import { twMerge } from "tailwind-merge";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Item title */
  title?: string;
  /** Item subtitle */
  subtitle?: string;
  /** Item description */
  description?: string;
  /** Children content */
  children: React.ReactNode;
  /** Additional CSS classes for outer container */
  className?: string;
  /** Additional CSS classes for inner content container */
  innerClassName?: string;
};

/**
 * A container component for outreach content sections.
 * Displays title, subtitle, description, and children content.
 */
export function OutreachItem({
  title,
  subtitle,
  description,
  children,
  className,
  innerClassName,
}: Props) {
  return (
    <div className={twMerge("flex flex-col gap-2 md:w-full", className)}>
      <div className="flex flex-col gap-2 md:max-w-sm">
        {title && <Type variant="h4">{title}</Type>}
        <div className="flex flex-col gap-2">
          {subtitle && (
            <Type variant="h5" className="max-w-fit">
              {subtitle}
            </Type>
          )}
          {description && (
            <Type variant="caption" className="max-w-fit">
              {description}
            </Type>
          )}
        </div>
      </div>
      <div className={twMerge("flex items-center mt-2", innerClassName)}>
        {children}
      </div>
    </div>
  );
}

